export default {"src":"/bnb/_next/static/media/cone.c4acf34b.svg","height":1208,"width":1207};